<div #container id="testsContainer" class="ocl-container-with-padding">
  <div #controls style="margin-bottom: 16px;">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <app-loading-header>Test Selection</app-loading-header>
      <dx-check-box [text]="'All tests'" [(value)]="showAllTestsInPicker"
                    (onValueChanged)="allTestsCheckboxValueChanged()"></dx-check-box>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between">
      <dx-text-box
        #codeTextBox
        class="uppercase"
        [disabled]="pickerDataSource === undefined || disabled"
        [placeholder]="'Code'"
        (onValueChanged)="textCodeChanged($event)"
        (onEnterKey)="pickerEnterKeyEvent()"
      ></dx-text-box>
      <dx-drop-down-box
        #testLookup
        [(value)]="pickerSelectedKeys"
        valueExpr="id"
        [disabled]="pickerDataSource === undefined || disabled"
        displayExpr="name"
        placeholder="Select a test..."
        [showClearButton]="true"
        [dataSource]="pickerDataSource.value"
        (onClosed)="cleanLookup()"
        (onOpened)="resizePickerDropDown()"
        style="width: 100%;margin-left: 4px;margin-right: 4px;">
        <div *dxTemplate="let data of 'content'" id="testsPickerContainer">
          <dx-data-grid
            #dropDownGrid
            [dataSource]="pickerDataSource.value"
            [columns]="['code', 'name', 'alternateNames']"
            [selection]="{ mode: 'multiple' }"
            [hoverStateEnabled]="true"
            [paging]="{ enabled: true, pageSize: 10 }"
            [filterRow]="{ visible: true }"
            [scrolling]="{ mode: 'infinite' }"
            [showRowLines]="true"
            [highlightChanges]="true"
            [allowColumnResizing]="true"
            style="min-width: 200px!important;"
            [showBorders]="true"
            [rowAlternationEnabled]="true"
            [wordWrapEnabled]="true"
            [columnAutoWidth]="true"
            [(selectedRowKeys)]="pickerSelectedKeys"
            [height]="'100%'"
            [width]="'100%'"
            [searchPanel]="{ visible: !isPhone, width: isPhone ? 228: 240, placeholder: 'Search...'}"
            [columnHidingEnabled]="isPhone">
            <dxo-remote-operations [filtering]="true" [paging]="true"></dxo-remote-operations>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
          </dx-data-grid>
        </div>
      </dx-drop-down-box>
      <div class="button-group">
        <dx-button
          [icon]="'add'"
          [disabled]="pickerDataSource === undefined || disabled"
          text="Add"
          style="margin-right: 4px;"
          (click)="addFoundTests()"
        ></dx-button>
        <dx-button
          [icon]="'trash'"
          [disabled]="pickerDataSource === undefined || disabled"
          text="Remove"
          (click)="removeSelectedTest()"
        ></dx-button>
      </div>
    </div>
  </div>
  <dx-tree-list
    [dataSource]="tests"
    [autoExpandAll]="false"
    [keyExpr]="'id'"
    [height]="450"
    [parentIdExpr]="'parentId'"
    [columnAutoWidth]="true"
    [wordWrapEnabled]="true"
    [allowColumnResizing]="true"
    [showBorders]="true"
    [loadPanel]="{enabled: false}"
    [showColumnLines]="true"
    [showRowLines]="true"
    [filterRow]="{ visible: true }"
    [selection]="{ mode: 'multiple', recursive: true }"
    [(selectedRowKeys)]="selectedKeys"
    (onNodesInitialized)="nodesInitialized($event)"
  >
    <dxo-scrolling [showScrollbar]="'always'" [mode]="'virtual'"></dxo-scrolling>
    <dxi-column dataField="code" [hidingPriority]="0"></dxi-column>
    <dxi-column dataField="name" [hidingPriority]="1"></dxi-column>
  </dx-tree-list>
</div>
